//Make sure that the import path is accurate.
import { env } from "../../core/Env"
import { rqx } from "../../core/request/API"

export const GetToolUsage = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/readToolUsage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/readToolUsage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GetToolActivePercentage = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/usagePercentage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/activePercentage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GetToolAwarePercentage = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/usagePercentage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/awarePercentage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GetToolUsagePercentage = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/usagePercentage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/usagePercentage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GetToolMostUsedPage = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/mostUsedPage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/mostUsedPage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GetToolUsageDetails = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/mostUsedPage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/usageDetails`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const CreateFeatureLogs = async(body) => {
    try {
        let result = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env()}/trail/featurelogs`, body)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GenerateRolePerTool = async(qsp) => {
    try {
        let result = await rqx.get(
            `<<global>>/${env() === 'local' ? 'dev' : env()}/reports/generateRolePerTool`,
            qsp
        )
        return result
    } catch (error) {
        return 'error'
    }
}